const SettingsPermissions = {
  edit: 'settings:edit',
  create: 'settings:create',
  delete: 'settings:delete',
  view: 'settings:view',
}

export default SettingsPermissions
